import styled from '@emotion/styled';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SOURCE_TYPES } from 'src/modules/user/models/user';
import { color } from 'src/shared/styles/variables';
import { CrisisModal } from './CrisisModal';

interface CrisisSupportWrapperProps {
    textOnly?: boolean;
}

const CrisisSupportWrapper = styled.div<CrisisSupportWrapperProps>(({ textOnly }) => ({
    letterSpacing: '0em',
    background: textOnly ? 'transparent' : color.lightSteelBlue,
    borderRadius: '4px',
    padding: '10px',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: textOnly ? '2em' : 0,
}));

const CrisisSupportMessage = styled.span({
    fontFamily: 'Avenir',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '16px',
    lineHeight: '24px',

    /* identical to box height, or 150% */
    cursor: 'pointer',
    textDecoration: 'none',

    /* Dark Grey */
    color: color.blueBayoux,
    opacity: 0.9,

    /* Add animation */
    ':hover': {
        color: color.blueBayoux,
        textDecoration: 'underline',
        textDecorationLine: 'underline',
    },
});

interface CrisisSupportBannerProps {
    textOnly?: boolean;
}

const CrisisSupportBanner: React.FC<CrisisSupportBannerProps> = ({ textOnly }) => {
    const { t } = useTranslation();
    const [showCrisisModal, setShowCrisisModal] = useState(false);
    const { showCrisisSupportV05 } = useFlags();

    const bannerText = t('shared:crisis_support_banner.message');

    return showCrisisSupportV05 ? (
        <>
            <CrisisSupportWrapper
                textOnly={textOnly}
                onClick={() => {
                    setShowCrisisModal(true);
                }}
            >
                <CrisisSupportMessage>{bannerText}</CrisisSupportMessage>
            </CrisisSupportWrapper>

            <CrisisModal
                visible={showCrisisModal}
                onClose={() => {
                    setShowCrisisModal(false);
                }}
                source={SOURCE_TYPES.HOME_PAGE}
            />
        </>
    ) : null;
};

export default CrisisSupportBanner;
